

let filterMenuToggles = document.querySelectorAll('.filter-menu-toggle');
let filterMenu = document.getElementById('facetsMenu');
filterMenuToggles.forEach((item) => {
  item.addEventListener('click', (e) => {
    filterMenu.classList.toggle('--open');
  });
});

let sortingMenuToggles = document.querySelectorAll('.sorting-menu-toggle');
let sortingMenu = document.getElementById('sortingMenu');
sortingMenuToggles.forEach((item) => {
  item.addEventListener('click', (e) => {
    sortingMenu.classList.toggle('--open');
  });
});

let mobileSortOptions = document.querySelectorAll('.facets-mobile-sorting .facets__title');
mobileSortOptions.forEach((item) => {
  item.addEventListener('click', (e) => {
    mobileSortOptions.forEach(el => el.classList.remove('--selected'));
    item.classList.add('--selected');
    document.getElementById('SortBy').value = item.dataset.sort;
    document.getElementById('FacetFiltersForm').dispatchEvent(new Event('input'));
  })
});


